import styled from "styled-components";

export const CollapseContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 1rem 0;
  padding: 1rem 2rem 0rem 2rem;
  gap: 1rem;
`;

export const CloseButton = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  top: -1rem;
  right: 1rem;

  background: transparent;

  border: none;

  color: #0e0e0e99;

  svg {
    font-size: 1.2em;
  }

  &:hover,
  &:focus {
    font-weight: bold;
  }
`;